module.exports = __webpack_public_path__ + "static/media/product-catalog-banner.46c7bc10.png";